const messages = {
  markAsExported: 'Mark as Exported',
  selectOne: 'Select one',
  selectIntegrationType: 'Select an integration to mark order as exported',
}

export default messages
